import { ValidatorFn, ValidationErrors, AbstractControl, FormGroup, FormArray } from '@angular/forms';

export function allOfValidator( config: { id: string, label?: string, value?: any }[] ): ValidatorFn {
   if ( !config?.length ) { return; }

   return ( control: AbstractControl ): ValidationErrors | null => {
      if ( control instanceof FormArray ) {
         return control.controls.map(( c, _index ) => allOfValidatorFunction( c, config ))
            .reduce(( a, c ) => ({ ...a, ...c }), {} );
      }

      if ( control instanceof FormGroup ) {
         return allOfValidatorFunction( control, config );
      }

      return null;
   }
}

function allOfValidatorFunction( control: AbstractControl, config = [] ) {
   if ( !control ) { return null; }
   if ( !config ) { return null; }

   // initial state
   if ( config.every( req => !control.get( req.id )?.value )) { return null; }

   // we can assume all controls have a value from here
   const allOf = config.map( req => {
      if ( control.get( req.id ) == null) { return null; } // control not here
      if ( req?.value && control.get( req.id ).value === req.value ) { return null; } // control is on the predefined value
      if ( control.get( req.id ).value ) { return null; } // has a value

      return req?.label ?? req.id;
   }).filter( _ => !!_ );

   return allOf.length ? { allOf }: null;
}
